import React, { useCallback, useEffect, useState } from 'react';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useMyAccount } from '../../../data/hooks/sessionHooks';
import { useIsBusy } from '../../../data/hooks/ui/useIsBusy';
import { handleAPIProvidedErrorMessage } from '../../../misc/handleAPIProvidedErrorMessage';
import { acceptPushNotifications } from '../../../misc/push-notifications/enablePushNotifications';
import { getPushNotificationsClientInstance } from '../../../misc/push-notifications/getPushNotificationsClientInstance';
import { rejectPushNotifications } from '../../../misc/push-notifications/rejectPushNotifications';
import Button from '../../elements/Button/Button';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import Checkbox from '../../elements/forms/Checkbox';
import LeftTabbedGrayHeader from '../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';
import ListingStatusPerEvent from './ListingStatusPerEvent/ListingStatusPerEvent';

function selectUser(state) {
    return state.session.user;
}

const MyProfileScreen_Privacy = (props) => {
    const {} = props,
        i18n = useI18n(),
        user = useMyAccount(),
        isBusy = useIsBusy(),
        [formState, setFormState] = useState({
            perEvent: [],
            pref_show_on_list: user.pref_show_on_list,
            pref_available_for_chat: user.pref_available_for_chat,
            pref_receive_email_notifications: user.pref_receive_email_notifications,
            pushNotificationsSubscribed: undefined, // async loaded in useEffect
        }),
        pushClient = getPushNotificationsClientInstance(),
        changePermissions = (formState.pushNotificationsSubscribed !== undefined && !pushClient.isPermissionAsked()) || pushClient.hasPermission();

    // Update form if push notifications state change
    useEffect(() => {
        (async function checkNotificationsStatus() {
            const client = getPushNotificationsClientInstance();
            if (!isBusy) {
                const subscription = await client.getSubscription(),
                    hasPermission = client.hasPermission();
                setFormState({
                    ...formState,
                    pushNotificationsSubscribed: hasPermission && subscription,
                });
            }
        })();
    }, [isBusy]);

    // change visibility per event
    const handleChangePerEventListingStatus = useCallback(
        (perEvent) => {
            setFormState({ ...formState, perEvent });
        },
        [formState]
    );

    // field change
    const handleChange = useCallback(
        (field, value) => {
            setFormState({ ...formState, [field]: value });
        },
        [formState]
    );

    // handle save / form submit
    const handleSubmit = useCallback(
        async (e) => {
            e.stopPropagation();
            e.preventDefault();

            app.store.dispatch(app.actions.ui.busy());

            const client = getPushNotificationsClientInstance(),
                subscription = client.getSubscription();
            try {
                console.log(formState.pushNotificationsSubscribed, !subscription);
                if (formState.pushNotificationsSubscribed) {
                    acceptPushNotifications();
                } else {
                    rejectPushNotifications();
                }
            } catch (e) {
                console.warn(e);
            }

            app.api.users
                .updateUserProfile(user.id, {
                    pref_show_on_list: formState.pref_show_on_list,
                    pref_available_for_chat: formState.pref_available_for_chat,
                    pref_receive_email_notifications: formState.pref_receive_email_notifications,
                    hide_or_show_in_events: formState.perEvent,
                })
                .then(
                    async function (user) {
                        await dialogAlert(i18n['msg.message.upload.profile']);
                        app.history.push('..');
                    }.bind(this)
                )
                .catch(handleAPIProvidedErrorMessage)
                .then(() => app.store.dispatch(app.actions.ui.free()));
        },
        [formState, user, i18n]
    );

    // header
    const header = (
        <>
            <TopBar returnURL=".." />
            <hr />
        </>
    );

    // screen output
    return (
        <Screen header={header}>
            <Scrollable>
                <form onSubmit={handleSubmit}>
                    <LeftTabbedGrayHeader>{i18n['label.pivacy.settings']}</LeftTabbedGrayHeader>
                    <div className="indent content">
                        <p>
                            <b>{i18n['label.privacy.participantlist']}</b>
                        </p>
                        <Checkbox checked={formState.pref_available_for_chat} onChange={(checked) => handleChange('pref_available_for_chat', checked)}>
                            {i18n['label.privacy.available']}
                        </Checkbox>
                        <br />
                        <Checkbox checked={formState.pref_show_on_list} onChange={(checked) => handleChange('pref_show_on_list', checked)}>
                            {i18n['label.privacy.seen']}
                        </Checkbox>
                        {formState.pref_show_on_list ? (
                            <>
                                <br />
                                <ListingStatusPerEvent perEvent={formState.perEvent} onChange={handleChangePerEventListingStatus} />
                            </>
                        ) : null}
                    </div>
                    <div className="indent content">
                        <p>
                            <b>{i18n['label.Notifications']}</b>
                        </p>
                        <Checkbox checked={formState.pref_receive_email_notifications} onChange={(checked) => handleChange('pref_receive_email_notifications', checked)}>
                            {i18n['label.privacy.email-notifications']}
                        </Checkbox>
                        {changePermissions ? (
                            <Checkbox checked={formState.pushNotificationsSubscribed} onChange={(checked) => handleChange('pushNotificationsSubscribed', checked)}>
                                {i18n['label.i.want.to.receive.push.notifications']}
                            </Checkbox>
                        ) : null}
                    </div>
                    <br />
                    <br />

                    <div className="content">
                        <Button type="submit" primary block>
                            {i18n['label.editprofile.store']}
                        </Button>
                    </div>
                </form>
            </Scrollable>
        </Screen>
    );
};

export default MyProfileScreen_Privacy;
